import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { memo, } from 'react';
import { Typography, Grid, } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { KeyboardIconSG, ToolIconSG, PromptToolIconSG } from '../components';
import { ACTION_TYPES, getTools } from './constants';
import { workflowStyles } from './workflowStyles';
/**
 * Custom Workflow Action component
 * @param props Props
 * @returns Custom Workflow Action
 */
export const WorkflowActionHeader = memo(function ({ action, }) {
    // Get translation function
    const { t, i18n } = useTranslation();
    const TOOLS = getTools();
    /**
     * Get Action icon
     * @returns Action icon
     */
    const getActionIcon = () => {
        const actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                return _jsx(KeyboardIconSG, { sx: { width: '48px', height: '48px' } });
            case ACTION_TYPES.TOOL:
                return _jsx(ToolIconSG, { sx: { width: '48px', height: '48px' } });
            case ACTION_TYPES.PROMPT:
                return _jsx(PromptToolIconSG, { sx: { width: '48px', height: '48px' } });
            default:
                return _jsx(PromptToolIconSG, { sx: { width: '48px', height: '48px' } });
        }
    };
    /**
     * Get Action title
     * @returns Action title
     */
    const getActionTitle = () => {
        const /** Workflow Action type */ actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                return 'Input';
                break;
            case ACTION_TYPES.TOOL:
                return 'Tool';
                break;
            case ACTION_TYPES.PROMPT:
                return 'Prompt';
                break;
            default:
                return 'Prompt';
        }
    };
    /**
     * Get Action subtitle
     * @returns Action Subtitle
     */
    const getActionSubtitle = () => {
        var _a;
        const /** Workflow Action type */ actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                const inputsNames = ((action === null || action === void 0 ? void 0 : action.inputs) || []).map((input) => (input === null || input === void 0 ? void 0 : input.name));
                return inputsNames.join(', ');
            case ACTION_TYPES.TOOL:
                return (_a = TOOLS[action === null || action === void 0 ? void 0 : action.tool]) === null || _a === void 0 ? void 0 : _a.name;
            case ACTION_TYPES.PROMPT:
                return action === null || action === void 0 ? void 0 : action.promptContent;
            default:
                return '';
        }
    };
    return (_jsxs(Grid, Object.assign({ container: true, sx: { alignItems: 'center', width: '100%', flexWrap: 'nowrap' } }, { children: [_jsx(Grid, Object.assign({ item: true, sx: { margin: '0 0.5rem 0 0' } }, { children: getActionIcon() })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsxs(Grid, Object.assign({ container: true, sx: { justifyContent: 'flex-start', width: 'calc(100%)' } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, sx: { overflow: 'hidden', width: '1px' } }, { children: _jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.actionTitle) }, { children: t(getActionTitle()) })) })), _jsx(Grid, Object.assign({ item: true, xs: 12, sx: { overflow: 'hidden', width: '1px' } }, { children: _jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.actionSubtitle) }, { children: getActionSubtitle() })) }))] })) }))] })));
});
